import { MousePointerClick } from 'lucide-react';
import type { ButtonBlock } from '@impact/types';
import type { BlockTypeConfig } from '../types';

export const buttonConfig: BlockTypeConfig<ButtonBlock> = {
  type: 'button',
  label: 'Button',
  description: 'Standalone button or link',
  icon: MousePointerClick,
  category: 'interactive',
  createDefault: () => ({
    text: 'Click here',
    url: '',
    style: 'primary',
    size: 'md',
    alignment: 'center',
  }),
  toolbar: [
    {
      kind: 'select',
      path: 'data.style',
      label: 'Style',
      options: [
        { value: 'primary', label: 'Primary' },
        { value: 'secondary', label: 'Secondary' },
        { value: 'outline', label: 'Outline' },
      ],
    },
    {
      kind: 'select',
      path: 'data.alignment',
      label: 'Align',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
    },
    { kind: 'variant' },
    { kind: 'divider' },
    { kind: 'more' },
  ],
  variants: [
    {
      id: 'default',
      label: 'Solid',
      thumbnail: '/admin/page-editor/variants/button-default.svg',
      apply: (d) => ({ ...d, variant: 'default', style: 'primary' }),
    },
    {
      id: 'arrow-link',
      label: 'Arrow link',
      thumbnail: '/admin/page-editor/variants/button-arrow-link.svg',
      apply: (d) => ({ ...d, variant: 'arrow-link' }),
    },
    {
      id: 'pill',
      label: 'Pill',
      thumbnail: '/admin/page-editor/variants/button-pill.svg',
      apply: (d) => ({ ...d, variant: 'pill' }),
    },
  ],
  sheet: [
    { kind: 'link', path: 'data.url', label: 'URL' },
    {
      kind: 'select',
      path: 'data.size',
      label: 'Size',
      options: [
        { value: 'sm', label: 'Small' },
        { value: 'md', label: 'Medium' },
        { value: 'lg', label: 'Large' },
      ],
    },
    { kind: 'toggle', path: 'data.fullWidth', label: 'Full width' },
    { kind: 'toggle', path: 'data.openInNewTab', label: 'Open in new tab' },
  ],
};
